module.exports = __webpack_public_path__ + "name=img/src/assets/projects/design/email-receipt.png?0dee0775637bef76ba559bfc1f14fe2c";